import React from "react";
import { MapPin, Utensils, Building2 } from "lucide-react";

export default function Location() {
  return (
    <section id="location" className="py-24 lg:py-36">
      <div className="container-max">
        <div className="mb-14">
          <span className="section-label">Location dei corsi</span>
          <h2 className="font-display text-4xl lg:text-6xl leading-[1] text-white mt-6 max-w-4xl">
            Montacchiello Campus — Pisa.<br />
            <span className="italic font-light text-white/60">Un luogo d’eccezione.</span>
          </h2>
          <p className="text-white/60 text-base lg:text-lg mt-6 max-w-3xl leading-relaxed">
            Abbiamo scelto il Campus Montacchiello, polo tecnologico d’eccellenza, perché crediamo che l’ambiente
            conti: una struttura pensata per favorire l’apprendimento, la concentrazione e lo scambio di valore
            tra professionisti.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-6">
          {/* Main hero — exterior building with lion statue */}
          <div className="lg:col-span-8 relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/5] lg:aspect-[16/10]">
            <img
              src="/location/exterior.jpg"
              alt="Montacchiello Campus — edificio esterno con statua del leone"
              className="w-full h-full object-cover"
              loading="lazy"
              data-testid="location-hero-exterior"
            />
            <div className="absolute inset-0 bg-gradient-to-tr from-black/70 via-black/10 to-transparent" />
            <div className="absolute bottom-6 left-6 right-6">
              <div className="inline-flex items-center gap-2 bg-black/50 backdrop-blur-md border border-white/10 rounded-full px-3 py-1.5 text-white/90 text-xs">
                <MapPin size={12} style={{ color: "#d4ff3d" }} /> Via Umberto Forti 6, 56021 Montacchiello, Pisa
              </div>
              <div className="font-display text-2xl lg:text-4xl text-white mt-4 max-w-2xl">
                Definita da alcuni la <span className="italic">Silicon Valley italiana</span>.
              </div>
            </div>
          </div>

          {/* Right column — two interior photos + info */}
          <div className="lg:col-span-4 flex flex-col gap-4">
            <div className="grid grid-cols-2 lg:grid-cols-1 gap-4">
              <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/3]">
                <img
                  src="/location/interior-1.webp"
                  alt="Aula meeting — Montacchiello Campus"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  data-testid="location-interior-1"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-3 left-3">
                  <span className="inline-flex items-center gap-1.5 bg-black/50 backdrop-blur-md rounded-full px-2.5 py-1 text-white/90 text-[10px] font-mono uppercase tracking-widest">
                    <span
                      className="w-1.5 h-1.5 rounded-full"
                      style={{ background: "#d4ff3d" }}
                    />
                    Meeting Two
                  </span>
                </div>
              </div>
              <div className="relative rounded-2xl overflow-hidden border border-white/10 aspect-[4/3]">
                <img
                  src="/location/interior-2.webp"
                  alt="Sala training — Montacchiello Campus"
                  className="w-full h-full object-cover"
                  loading="lazy"
                  data-testid="location-interior-2"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <div className="absolute bottom-3 left-3">
                  <span className="inline-flex items-center gap-1.5 bg-black/50 backdrop-blur-md rounded-full px-2.5 py-1 text-white/90 text-[10px] font-mono uppercase tracking-widest">
                    <span
                      className="w-1.5 h-1.5 rounded-full"
                      style={{ background: "#d4ff3d" }}
                    />
                    Training Room
                  </span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 lg:grid-cols-1 gap-4">
              <div className="bg-card border border-white/10 rounded-2xl p-5 lg:p-6 flex-1">
                <Building2 size={20} style={{ color: "#d4ff3d" }} />
                <div className="font-display text-lg lg:text-xl text-white mt-3">La struttura</div>
                <p className="text-white/60 text-xs lg:text-sm mt-2 leading-relaxed">
                  Aule perfettamente attrezzate, sale ristoro e spazi pensati per l’apprendimento e il networking.
                </p>
              </div>
              <div className="bg-card border border-white/10 rounded-2xl p-5 lg:p-6 flex-1">
                <Utensils size={20} style={{ color: "#d4ff3d" }} />
                <div className="font-display text-lg lg:text-xl text-white mt-3">Pausa pranzo inclusa</div>
                <p className="text-white/60 text-xs lg:text-sm mt-2 leading-relaxed">
                  Light lunch presso Main Kitchen, a pochi metri dal Campus. Un momento conviviale per conoscerci meglio.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
